<template>
  <div>
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-position="top"
      class="dataForm"
      :rules="rules"
    >
      <div class="logisticsInfo logisticsInfo-edit">
        <h3>发货信息</h3>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="送货方式"
              prop="sendType"
            >
              <el-select
                v-model="dataForm.sendType"
                placeholder
              >
                <el-option
                  v-for="option in options.sendType"
                  :key="option.value"
                  :label="option.desc"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 上门自提 -->
          <template v-if="dataForm.sendType === '01'">
            <el-col :span="8">
              <el-form-item
                label="身份证号码"
                prop="idCard"
              >
                <el-input
                  v-model="dataForm.idCard"
                  clearable
                />
              </el-form-item>
            </el-col>
          </template>

          <!-- 物流送货 -->
          <template v-else-if="dataForm.sendType === '02'">
            <el-col :span="8">
              <el-row class="merge-input">
                <el-col :span="12">
                  <el-form-item
                    label="要求送达时间"
                    prop="expectSendDate"
                  >
                    <el-date-picker
                      v-model="dataForm.expectSendDate"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      placeholder="日期"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="　"
                    prop="deliveryTimeType"
                  >
                    <el-select
                      v-model="dataForm.deliveryTimeType"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in [{desc: '上午', value: '01'},{desc: '下午', value: '02'},{desc: '指定时间', value: '03'}]"
                        :key="item.value"
                        :label="item.desc"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="8"
              v-if="dataForm.deliveryTimeType == '03'"
            >
              <el-form-item
                label="具体时间"
                prop="deliveryTimeLabel"
              >
                <el-time-select
                  v-model="dataForm.deliveryTimeLabel"
                  start="06:30"
                  step="00:15"
                  end="18:30"
                  placeholder="选择时间"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="签收方式"
                prop="deliverySignatureMode"
              >
                <el-select
                  v-model="dataForm.deliverySignatureMode"
                  @change="deliverySignatureModeChange"
                  placeholder
                >
                  <el-option
                    v-for="option in options.signType"
                    :key="option.value"
                    :label="option.desc"
                    :value="option.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-if="dataForm.deliverySignatureMode == '2'"
            >
              <el-form-item
                label="身份证号码"
                prop="idCard"
              >
                <ab-history
                  v-model.trim="dataForm.idCard"
                  ref="abHistory"
                  :historyKey="dataForm.princiPalIdDesc"
                ></ab-history>
              </el-form-item>
            </el-col>
          </template>

          <!-- 快递送货 -->
          <template v-else-if="dataForm.sendType === '03'">
            <el-col :span="8">
              <el-form-item
                label="付费方式"
                prop="payType"
              >
                <el-select
                  v-model="dataForm.payType"
                  placeholder
                >
                  <el-option
                    v-for="option in options.payType"
                    :key="option.value"
                    :label="option.desc"
                    :value="option.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </template>
        </el-row>

        <!-- 上门自提 物流送货 快递送货 -->
        <template v-if="['01', '02', '03'].includes(dataForm.sendType)">
          <el-form-item prop="supplierName">
            <!-- 进口 我的地址 -->
            <ab-select2
              v-if="dataForm.bizBigType === '01'"
              v-model="dataForm.receiveCompanyName"
              url="/bas/client/basAddress/list"
              :urlData="{ data: { companyName: dataForm.receiveCompanyName, addressType: '01', isEnabled: 1 } }"
              inputKey="companyName"
              :label="dataForm.sendType === '01' ? '提货公司' : '收货公司'"
              required
              @handleSelect="receiveCompanySelect"
              @handlerAdd="receiveCompanyAdd"
            >
            </ab-select2>
            <!-- 出口 客户下地址 -->
            <ab-select2
              v-else
              v-model="dataForm.receiveCompanyName"
              url="/bas/client/basCustomer/checkAddress"
              :urlData="{ keyWord: dataForm.receiveCompanyName }"
              inputKey="keyWord"
              descKey="company"
              :label="dataForm.sendType === '01' ? '提货公司' : '收货公司'"
              required
              @handleSelect="customerReceiveCompanySelect"
              @handlerAdd="receiveCompanyAdd"
            >
            </ab-select2>
          </el-form-item>

          <div
            v-if="dataForm.receiveCompanyName"
            class="receivingAddress"
          >
            <ab-svg name="dingwei"></ab-svg>
            {{ dataForm.receiveAddress }}/{{ dataForm.receiveLink }}/{{ dataForm.receivePhone }}
          </div>

          <el-form-item
            label="备注"
            class="remark"
          >
            <el-input
              v-model="dataForm.remark"
              :rows="1"
              type="textarea"
              placeholder="有什么问题可以在这里备注哟！"
              :autosize="{ maxRows: 5 }"
              resize="none"
            />
          </el-form-item>
        </template>
      </div>

      <div class="goodsInfo">
        <div class="title">
          <h3>货物信息</h3>
          <div>
            <el-button @click="materielDown">模板下载</el-button>

            <el-upload
              style="display:inline-block;margin:0 10px;"
              action
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <el-button
                :loading="loading.import"
                plain
              >批量导入</el-button>
            </el-upload>

            <el-button
              :loading="loading.export"
              @click="materielExport"
            >导出</el-button>
          </div>
        </div>

        <vxe-table
          v-if="isReload"
          class="materialTable"
          border
          resizable
          show-header-overflow
          show-overflow
          auto-resize
          :edit-rules="rules"
          ref="xTable"
          max-height="540"
          :header-cell-style="rowStyle"
          :data="dataForm.entry"
          :edit-config="{ trigger: 'click', mode: 'row', showUpdateStatus: true, icon: 'none' }"
        >
          <vxe-table-column type="seq" title="序号" width="50" align="center" fixed="left"></vxe-table-column>
          <vxe-table-column field="clientNumber" title="订单编号" width="160"></vxe-table-column>
          <vxe-table-column field="model" title="型号" width="140"></vxe-table-column>
          <vxe-table-column field="brand" title="品牌" width="140"></vxe-table-column>
          <vxe-table-column field="declareGoodsName" title="品名" width="140"></vxe-table-column>
          <vxe-table-column field="originPlaceIdDesc" title="产地" width="140"></vxe-table-column>
          <vxe-table-column field="qty" title="订单数量" width="100"></vxe-table-column>
          <vxe-table-column field="canDeliveredQty" title="可发数量" width="100"></vxe-table-column>
          <vxe-table-column field="unitName" title="基本单位" width="100"></vxe-table-column>
          <vxe-table-column field="sendQty" title="本次数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }">
            <template v-slot:edit="{ row }" >
              <el-input v-model="row.sendQty" @change="sendQtyChange(row)" placeholder="请输入"></el-input>
            </template>
          </vxe-table-column>          
          <vxe-table-column field="piece" title="件数" width="100" :edit-render="{ autofocus: '.el-input__inner' }">
            <template v-slot:edit="{ row }" >
              <el-input v-model="row.piece" placeholder="请输入"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="grossWeight" title="毛重（kg）" width="120" :edit-render="{ autofocus: '.el-input__inner' }">
            <template v-slot:edit="{ row }" >
              <el-input v-model="row.grossWeight" placeholder="请输入"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="cardBoard" title="卡板数" width="100" :edit-render="{ autofocus: '.el-input__inner' }">
            <template v-slot:edit="{ row }" >
              <el-input v-model="row.cardBoard" placeholder="请输入"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="custMatNo" title="料号" width="140"></vxe-table-column>
          <vxe-table-column field="custOrderNo" title="我司单号" width="160"></vxe-table-column>
          <vxe-table-column title="操作" width="80" align="center" fixed="right">
            <template v-slot="scope">
              <el-button
                type="text"
                class="delete-list"
                @click="deleteTabItem(scope.row, scope.rowIndex)"
                :disabled="dataForm.entry.length === 1"
              >删除</el-button>
            </template>
          </vxe-table-column>
        </vxe-table>

        <el-row>
          <el-col :span="6">
            <span>总数量</span>
            <div class="number">{{ sendQtySum }}</div>
          </el-col>
          <el-col :span="6">
            <span>总件数</span>
            <div class="number">{{ pieceSum }}</div>
          </el-col>
          <el-col :span="6">
            <span>总毛重（kg）</span>
            <div class="number">{{ grossWeightSum }}</div>
          </el-col>
          <el-col :span="6">
            <span>总卡板数</span>
            <div class="number">{{ cardBoardSum }}</div>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <ab-handlerAds
      :dialog="addressData"
      ref="handlerAds"
      @change="handlerAddress"
    ></ab-handlerAds>
  </div>
</template>

<script>
export default {
  name: 'logistics-detail-edit',
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    },

    dataForm: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    const idCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号码'))
      } else if (!/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error('请输入正确的18位身份证号码'))
      } else {
        callback()
      }
    }

    return {
      rules: {
        sendType: [
          { required: true, message: '请选择送货方式', trigger: 'change' }
        ],

        expectSendDate: [
          { required: true, message: '请选择准确时间', trigger: 'change' }
        ],

        deliveryTimeType: [
          { required: true, message: '请选择要求送货时间', trigger: 'change' }
        ],

        deliveryTimeLabel: [
          { required: true, message: '请选择具体时间', trigger: 'change' }
        ],

        receiveCompanyName: [
          { required: true, message: '请选择公司名称', trigger: 'change' }
        ],

        deliverySignatureMode: [
          { required: true, message: '请选择签收方式', trigger: 'change' }
        ],

        idCard: [
          { required: true, validator: idCard, trigger: 'blur' }
        ],

        payType: [
          { required: true, message: '请选择付费方式', trigger: 'change' }
        ],

        remark: [
          { max: 50, message: '最大长度为50个字符', trigger: 'blur' }
        ],

        sendQty: [
          { required: true, message: '请填写本次数量' },
          { validator: ({ cellValue }) => {
              if (cellValue && !/^\d{1,11}(\.\d{1,3})?$/.test(cellValue)) {
                return new Error('请输入最长11位整数，3位小数')
              }
            }
          }
        ],
        piece: [
          { required: true, message: '请填写件数' },
          { validator: ({ cellValue }) => {
              if (cellValue && !/^(?=([0-9]{1,10}$|[0-9]{1,8}\.))(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(cellValue)) {
                return new Error('请输入数字，最大长度10位，保留两位小数')
              }
            }
          }
        ],
        grossWeight: [
          { required: true, message: '请填写毛重' },
          { validator: ({ cellValue }) => {
              if (cellValue && !/^\d{1,11}(\.\d{1,4})?$/.test(cellValue)) {
                return new Error('请输入最长11位整数，4位小数')
              }
            }
          }
        ],
        cardBoard: [
          { validator: ({ cellValue }) => {
              if (cellValue && !/^\d{1,15}$/.test(cellValue)) {
                return new Error('请输入整数，最大15位')
              }
            }
          }
        ]
      },
      addressData: {
        type: '01', //业务类型 01 进口，02 出口
        addressType: '01', //地址类型 01收货，04发货
        isEnabled: true,
        show: false
      },
      loading: {
        import: false,
        export: false
      },
      isReload: true
    }
  },

  computed: {
    // 总数量
    sendQtySum() {
      return this.dataForm.entry
        .map((row) => row.sendQty)
        .reduce((acc, cur) => {
          if (!cur || isNaN(cur)) {
            cur = 0
          }
          return this.$calc.add(cur, acc)
        }, 0)
    },

    // 总件数
    pieceSum() {
      return this.dataForm.entry
        .map((row) => row.piece)
        .reduce((acc, cur) => {
          if (!cur || isNaN(cur)) {
            cur = 0
          }
          return this.$calc.add(cur, acc)
        }, 0)
    },

    // 总毛重
    grossWeightSum() {
      return this.dataForm.entry
        .map((row) => row.grossWeight)
        .reduce((acc, cur) => {
          if (!cur || isNaN(cur)) {
            cur = 0
          }
          return this.$calc.add(cur, acc)
        }, 0)
    },

    // 总卡板数
    cardBoardSum() {
      return this.dataForm.entry
        .map((row) => row.cardBoard)
        .reduce((acc, cur) => {
          if (!cur || isNaN(cur)) {
            cur = 0
          }
          return this.$calc.add(cur, acc)
        }, 0)
    }
  },

  mounted() {

  },

  methods: {
    // 收货公司-进口
    receiveCompanySelect(row) {
      if (!row) {
        this.dataForm.addressId = ''
        this.dataForm.receiveAreaId = ''
        this.dataForm.addressIdsName = ''
        this.dataForm.receiveAddress = ''
        this.dataForm.receiveLink = ''
        this.dataForm.receivePhone = ''
      } else {
        this.dataForm.addressId = row.id
        this.dataForm.receiveAreaId = row.addressIds
        this.dataForm.addressIdsName = row.addressIdsName
        this.dataForm.receiveAddress = row.addressContent
        this.dataForm.receiveLink = row.linkMan
        this.dataForm.receivePhone = row.linkPhone
      }
    },

    // 收货地址-出口
    customerReceiveCompanySelect(row) {
      if (!row) {
        this.dataForm.addressId = ''
        this.dataForm.receiveAreaId = ''
        this.dataForm.receiveAddress = ''
        this.dataForm.receiveLink = ''
        this.dataForm.receivePhone = ''
      } else {
        this.dataForm.addressId = row.id
        this.dataForm.receiveAreaId = row.areaId
        this.dataForm.addressIdsName = row.addressIdsName
        this.dataForm.receiveAddress = row.takeAddress
        this.dataForm.receiveLink = row.linkman
        this.dataForm.receivePhone = row.mobile
        this.dataForm.receiveCompanyName = row.company
      }
    },

    // 收货公司-进/出口-新增
    receiveCompanyAdd() {
      this.addressData.type = this.dataForm.bizBigType
      this.addressData.show = true
    },

    // 签收方式
    deliverySignatureModeChange(value) {
      if (value != '2') {
        this.dataForm.idCard = ''
      }
    },

    // 地址
    handlerAddress(row) {
      this.dataForm.receiveAddress = row.addressContent
      this.dataForm.addressId = row.id
      this.dataForm.receiveAreaId = row.addressIds
      this.dataForm.addressIdsName = row.areaDesc
      this.dataForm.receiveCompanyName = row.companyName
      this.dataForm.receiveLink = row.linkMan
      this.dataForm.receivePhone = row.linkPhone
    },

    // 模板下载
    materielDown() {
      window.open(
        'https://scp-static.oss-cn-shenzhen.aliyuncs.com/dev/SendNotice/%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      )
    },

    // 批量导入
    beforeAvatarUpload(file) {
      let fd = new FormData()
      fd.append('file', file)
      this.loading.import = true
        this.uploadReq(fd).then(({ data }) => {
            if (data && data.code === 'C0000') {
                /* let key = Object.keys(this.dataForm.entry)
                let arrry = [] */
                data.result.forEach((row, index) => {
                    this.dataForm.entry.forEach((item) => {
                        if (row.seqNum === item.seqNum) {
                            item.sendQty = row.sendQty
                            item.piece = row.piece
                            item.grossWeight = row.grossWeight
                            item.cardBoard = row.cardBoard
                            item.custMatNo = row.custMatNo
                            item.custOrderNo = row.custOrderNo
                        }
                    })
                    /* if(!key.includes(row.seqNum)){
                       arrry.push(row)
                    } */
                })
                // this.dataForm.entry = this.dataForm.entry.concat(arrry)
                this.$message({
                    message: data.message || '导入成功',
                    type: 'success',
                    duration: 1500,
                    offset: 380,
                    grouping: true
                })
                this.tableReload()
            }
        }).finally(() => {
            this.loading.import = false
        })
        return false
    },

    uploadReq(data) {
      return this.$http({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: this.$adornUrl('/tms/client/sendNotice/entryImport'),
        timeout: 50000,
        data: data
      })
    },

    // 导出
    materielExport() {
      let excelField = [
        'seqNum',
        'entrustNumber',
        'model',
        'brand',
        'declareGoodsName',
        'originPlaceIdDesc',
        'qty',
        'canDeliveredQty',
        'unitName',
        'sendQty',
        'piece',
        'grossWeight',
        'cardBoard',
        'custMatNo',
        'custOrderNo'
      ]
      let params = Object.assign(
        {},
        this.dataForm.id ? { id: this.dataForm.id } : this.dataForm,
        { excelField: excelField }
      )
      this.$post(
        '/tms/client/sendNotice/entryExport',
        params,
        this.loading,
        'export'
      ).then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.message
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        }
      })
    },

    // 表头样式
    rowStyle({ $rowIndex, column, columnIndex, $columnIndex }) {
      if(column.title == '本次数量') {
        return 'color: #fa7f14'
      }
    },

    // 本次数量修改
    sendQtyChange(row) {
      if (!isNaN(row.sendQty) && !isNaN(row.canDeliveredQty) && row.sendQty > row.canDeliveredQty) {
        this.$message({
          message: '输入的本次数量不能大于可发数量',
          type: 'warning',
          offset: 380,
          grouping: true
        })
        row.sendQty = row.canDeliveredQty
      }
      if (row.grossWeightOld && !isNaN(row.sendQty)) {
        row.grossWeight = this.$calc.mul(this.$calc.div(row.sendQty, row.qty), row.grossWeightOld).toFixed(2)
      }
      row.piece = this.$calc.mul(this.$calc.div(row.sendQty, row.canDeliveredQty), row.pieceOld).toFixed(2)
    },

    // 删除行
    deleteTabItem(row, index) {
      this.$confirm('确定删除该行数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.action === 2 && row.id) {
          row.action = 3
          this.$emit('deleteEntry', row)
        }
        this.dataForm.entry.splice(index, 1)
        this.tableReload()
      }).catch(() => {})
    },

    // 表格重载
    tableReload () {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    }
  }
}
</script>

<style lang="scss">
.logisticsInfo.logisticsInfo-edit {
    margin-bottom: 25px;
}
</style>
